<template>
	<div class="head-image" @click="showUserInfo($event)" :style="{ cursor: isShowUserInfo ? 'pointer' : null }">
		<!-- 图片头像：只要有有效URL就显示，加载失败会自动切换到文本头像 -->
		<img class="avatar-image"
			v-if="validUrl && !imageError"
			:src="validUrl"
			:style="avatarImageStyle"
			@load="handleImageLoad"
			@error="handleImageError" />
		<!-- 文本头像：没有URL或图片加载失败时显示 -->
		<div class="avatar-text" v-if="!validUrl || imageError" :style="avatarTextStyle">
			{{ displayText }}
		</div>
		<div v-show="online" class="online" title="用户当前在线"></div>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "headImage",
	data() {
		return {
			imageError: false,
			imageLoaded: false, // 🔥 新增：图片是否已加载完成
			colors: ["#5daa31", "#c7515a", "#e03697", "#85029b",
				"#c9b455", "#326eb6", "#ff6b6b", "#4ecdc4",
				"#45b7d1", "#96ceb4", "#feca57", "#ff9ff3"
			]
		}
	},
	props: {
		id: {
			type: Number
		},
		size: {
			type: Number,
			default: 42
		},
		width: {
			type: Number
		},
		height: {
			type: Number
		},
		radius: {
			type: String,
			default: "50%"
		},
		url: {
			type: String
		},
		name: {
			type: String,
			default: null
		},
		online: {
			type: Boolean,
			default: false
		},
		isShowUserInfo: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		showUserInfo(e) {
			if (!this.isShowUserInfo) return;
			if (this.id && this.id > 0) {
				this.$http({
					url: `/user/find/${this.id}`,
					method: 'get'
				}).then((user) => {
					this.$store.commit("setUserInfoBoxPos", e);
					this.$store.commit("showUserInfoBox", user);
				}).catch(() => {
					// 静默处理错误
				})
			}
		},
		// 图片加载完成处理
		handleImageLoad() {
			this.imageLoaded = true;
			this.imageError = false;
		},
		// 图片加载失败处理
		handleImageError() {
			this.imageError = true;
			this.imageLoaded = false;
		},
		// 预加载图片
		preloadImage(url) {
			if (!url || this.imageError) return;

			// 重置状态
			this.imageLoaded = false;
			this.imageError = false;

			// 如果图片已经在浏览器缓存中，可能会立即触发load事件
			// 所以不需要额外的预加载逻辑，让img标签自己处理即可
		}
	},
	computed: {
		validUrl() {
			const url = this.url;
			if (!url || typeof url !== 'string') {
				return null;
			}

			const trimmedUrl = url.trim();
			if (!trimmedUrl) {
				return null;
			}

			// 检查是否是emoji（单个字符且不是常规URL）
			if (trimmedUrl.length <= 4 && !trimmedUrl.includes('http') && !trimmedUrl.includes('.')) {
				return null; // emoji应该显示为文本，不是图片
			}

			return trimmedUrl;
		},
		displayText() {
			const url = this.url;
			const name = this.name;
			
			// 如果URL是emoji，直接显示emoji
			if (url && typeof url === 'string') {
				const trimmedUrl = url.trim();
				if (trimmedUrl.length <= 4 && !trimmedUrl.includes('http') && !trimmedUrl.includes('.')) {
					return trimmedUrl; // 直接返回emoji
				}
			}
			
			// 否则使用名称的前两个字符
			if (name && typeof name === 'string' && name.trim()) {
				const trimmed = name.trim();
				if (trimmed.length >= 2) {
					return trimmed.substring(0, 2).toUpperCase();
				} else if (trimmed.length === 1) {
					return trimmed.toUpperCase();
				}
			}
			
			return "👤";
		},
		avatarImageStyle() {
			let w = this.width ? this.width : this.size;
			let h = this.height ? this.height : this.size;
			return `width:${w}px; height:${h}px;
					border-radius: ${this.radius};`
		},
		avatarTextStyle() {
			let w = this.width ? this.width : this.size;
			let h = this.height ? this.height : this.size;
			return `
				  width: ${w}px;height:${h}px;
					background-color: ${this.textBackgroundColor};
					font-size:${w * 0.35}px;
					border-radius: ${this.radius};
					color: white;
					font-weight: bold;
					`
		},
		textBackgroundColor() {
			const name = this.name;
			if (!name || typeof name !== 'string' || !name.trim()) {
				return '#cccccc';
			}
			
			let hash = 0;
			for (let i = 0; i < name.length; i++) {
				hash += name.charCodeAt(i);
			}
			return this.colors[hash % this.colors.length];
		},
		textColor() {
			let hash = 0;
			for (var i = 0; i < this.name.length; i++) {
				hash += this.name.charCodeAt(i);
			}
			return this.colors[hash % this.colors.length];
		},
		// 🔥 新增：是否显示图片（只有在有效URL且图片已加载完成且没有错误时才显示）
		showImage() {
			return this.validUrl && this.imageLoaded && !this.imageError;
		}
	},
	watch: {
		// 🔥 优化：URL变化时的处理
		url: {
			handler(newUrl, oldUrl) {
				// 只有当URL真正发生变化时才重置状态
				if (newUrl !== oldUrl) {
					this.preloadImage(newUrl);
				}
			},
			immediate: false
		}
	},
	// 🔥 新增：组件挂载时处理初始图片
	mounted() {
		if (this.validUrl) {
			this.preloadImage(this.validUrl);
		}
	}
}
</script>

<style scoped lang="scss">
.head-image {
	position: relative;
	//cursor: pointer;

	.avatar-image {
		position: relative;
		overflow: hidden;
		display: block;
	}

	.avatar-text {
		color: white;
		display: flex;
		align-items: center;
		justify-content: center;
		//border: 1px solid #ccc;
		//box-shadow: var(--im-box-shadow);
	}

	.online {
		position: absolute;
		right: -5px;
		bottom: 0;
		width: 12px;
		height: 12px;
		background: limegreen;
		border-radius: 50%;
		border: 2px solid white;
	}
}
</style>